import { render } from "./NotificationCentrum.vue?vue&type=template&id=805c97d6&scoped=true"
import script from "./NotificationCentrum.vue?vue&type=script&lang=js"
export * from "./NotificationCentrum.vue?vue&type=script&lang=js"

import "./NotificationCentrum.vue?vue&type=style&index=0&id=805c97d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-805c97d6"]])

export default __exports__